import type { HyperliquidSpotClearinghouseState } from "./types";

export const HL_CHAIN_ID = 1337;
export const HL_USDC_ADDRESS = "0x00000000000000000000000000000000";
export const HL_USDC_DECIMALS = 6;
export const HL_POLL_INTERVAL = 5_000;
/**
 * Slower poll cadence used by surfaces where HL balance is a UX hint, not
 * real-time state — gas-warning badges in the workflow canvas, where N nodes
 * subscribe to the same address and a 5s cascade is wasteful. Keep the 5s
 * default for live trading surfaces (positions tab, wallet management).
 */
export const HL_GAS_BADGE_POLL_INTERVAL = 30_000;

export const HYPERLIQUID_ICON_URL = "/images/integrations/hyperliquid.png";

export function parseHlSpotUsdc(spot: HyperliquidSpotClearinghouseState | undefined): number {
  return parseFloat(spot?.balances?.find(b => b.coin === "USDC")?.total ?? "0");
}
